// Legal pages (Terms of Use / Privacy Policy / Cookie Policy).
// The backend owns the content and publish state; `GET /v1/config` returns
// `legal_links: { terms_of_use, privacy_policy, cookie_policy }`, each
// `{ title, url }` or null when unpublished. `url` is our own path
// (/terms-of-use, ...) when we host the page, or the client's https URL.

export const LEGAL_DOCS = [
  {
    type: "terms_of_use",
    label: "Terms of Use",
    path: "/terms-of-use",
    legacyPath: "/Terms-And-Conditions",
    envUrl: () => process.env.REACT_APP_TERMS_URL,
  },
  {
    type: "privacy_policy",
    label: "Privacy Policy",
    path: "/privacy-policy",
    legacyPath: "/Privacy-Policy",
    envUrl: () => process.env.REACT_APP_PRIVACY_POLICY_URL,
  },
  {
    type: "cookie_policy",
    label: "Cookie Policy",
    path: "/cookie-policy",
    legacyPath: "/Cookie-policy",
    envUrl: () => process.env.REACT_APP_COOKIE_POLICY_URL,
  },
];

export const isExternalUrl = (url) => /^https?:\/\//i.test(String(url || ""));

/**
 * Footer / Settings legal links.
 * - config has `legal_links` → follow it (null = hidden, http(s) = external tab,
 *   anything else = internal route).
 * - config missing (still loading / failed) or an older backend without
 *   `legal_links` → fall back to the build-time env vars, as before.
 * Returns [{ type, label, href, external }].
 */
export function buildLegalLinks(config) {
  const fromBackend =
    config && typeof config === "object" && config.legal_links && typeof config.legal_links === "object"
      ? config.legal_links
      : null;

  return LEGAL_DOCS.map((doc) => {
    if (fromBackend) {
      const link = fromBackend[doc.type];
      if (!link || !link.url) return null;
      return {
        type: doc.type,
        label: link.title || doc.label,
        href: link.url,
        external: isExternalUrl(link.url),
      };
    }
    const href = doc.envUrl();
    if (!href) return null;
    return { type: doc.type, label: doc.label, href, external: isExternalUrl(href) };
  }).filter(Boolean);
}
